class BundleDeals extends HTMLElement {
  constructor() {
    (super(),
      (this.productContainers = this.querySelectorAll('.bundle-deals__product-js')),
      (this.mediaItemContainers = this.querySelectorAll('.bundle-deals__media-item-container-js')),
      (this.mediaItemImgs = this.querySelectorAll('.bundle-deals__media-item-img-js')),
      (this.checkboxes = this.querySelectorAll('.bundle-deals__checkbox-js')),
      (this.variantPickers = this.querySelectorAll('.bundle-deals__variant-selects-js')),
      (this.skipNonExistent = this.dataset.skipNonExistent === 'true'),
      (this.skipUnavailable = this.dataset.skipUnavailable === 'true'),
      (this.prices = this.querySelectorAll('.bundle-deals__price-js')),
      (this.comparePrices = this.querySelectorAll('.bundle-deals__compare-price-js')),
      (this.totalPrice = this.querySelector('.bundle-deals__total-price-js')),
      (this.totalComparePrice = this.querySelector('.bundle-deals__total-compare-price-js')),
      (this.updatePrices = this.dataset.updatePrices === 'true'),
      (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
      (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
      (this.currencySymbol = this.dataset.currencySymbol),
      (this.selectedVariants = {
        id_1: null,
        id_2: null,
        id_3: null,
        id_4: null,
        id_5: null,
      }),
      (this.formVariants = []),
      this.initIds(),
      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
      }),
      this.variantPickers.forEach((picker) => {
        picker.addEventListener('change', this.handleSelectChange.bind(this));
      }));
  }
  initIds() {
    (this.checkboxes.forEach((checkbox) => {
      this.selectedVariants[checkbox.dataset.idIndex] = {
        id: checkbox.dataset.id,
        price: checkbox.dataset.price,
        comparePrice: checkbox.dataset.comparePrice,
        checked: true,
      };
    }),
      this.updateFormIds());
  }
  handleCheckboxChange(event) {
    const target = event.currentTarget,
      checked = target.checked,
      index = parseInt(target.dataset.index);
    this.selectedVariants[target.dataset.idIndex].checked = checked;
    const productContainer = this.productContainers[index],
      selects = productContainer.querySelectorAll('select');
    checked
      ? (this.mediaItemContainers[index].classList.remove('bundle-deals__media-item--disabled'),
        productContainer.classList.remove('bundle-deals__product--deselected'),
        selects.forEach((sel) => {
          sel.removeAttribute('disabled');
        }))
      : (this.mediaItemContainers[index].classList.add('bundle-deals__media-item--disabled'),
        productContainer.classList.add('bundle-deals__product--deselected'),
        selects.forEach((sel) => {
          sel.setAttribute('disabled', '');
        }));
    this.updateFormIds();
    if (this.updatePrices) this.updateTotalPrice();
  }
  handleSelectChange(event) {
    const target = event.currentTarget,
      index = parseInt(target.dataset.index),
      selectedValues = Array.from(target.querySelectorAll('select'), (s) => s.value),
      filteredVariants = JSON.parse(
        target.querySelector('[type="application/json"]').textContent,
      ).filter((v) => target.querySelector(':checked').value === v.option1),
      selects = [...target.querySelectorAll('.select--small')];
    updateVariantStatuses(filteredVariants, selects);
    const variant = JSON.parse(
      target.querySelector('[type=\x22application/json\x22]').textContent,
    ).find((v) => {
      return !v.options
        .map((opt, i) => {
          return selectedValues[i] === opt;
        })
        .includes(false);
    });
    if (!variant) {
      if (this.skipNonExistent)
        findAvailableVariant(target, selectedValues, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !variant.available) {
      if (findAvailableVariant(target, selectedValues, false, true, true)) return;
    }
    let { price: price, compare_at_price: compareAtPrice, featured_image: featuredImage } = variant;
    price = parseInt(price);
    let comparePrice = compareAtPrice ? parseInt(compareAtPrice) : price;
    const percentageLeft = target.dataset.percentageLeft ?? 1,
      fixedDiscount = target.dataset.fixedDiscount ?? 0;
    price = price * percentageLeft - fixedDiscount;
    if (featuredImage) featuredImage = featuredImage.src;
    const variantId = variant.id;
    ((this.selectedVariants[target.dataset.idIndex].id = variantId),
      (this.selectedVariants[target.dataset.idIndex].price = price),
      (this.selectedVariants[target.dataset.idIndex].comparePrice = comparePrice),
      this.updateFormIds(),
      this.updatePrices &&
        ((this.prices[index].innerHTML = this.currencySymbol + (price / 100).toFixed(2)),
        comparePrice > price
          ? (this.comparePrices[index].innerHTML =
              this.currencySymbol + (comparePrice / 100).toFixed(2))
          : (this.comparePrices[index].innerHTML = ''),
        this.updateTotalPrice()),
      featuredImage &&
        featuredImage.length > 0 &&
        this.mediaItemImgs[index] &&
        (this.mediaItemImgs[index].src = featuredImage));
  }
  updateFormIds() {
    const items = [],
      variants = this.selectedVariants;
    for (const key in variants) {
      const variant = variants[key];
      if (variant != null && variant.checked) {
        const existingIdx = items.findIndex((item) => item.id === variant.id);
        existingIdx < 0
          ? items.unshift({
              id: variant.id,
              quantity: 1,
            })
          : (items[existingIdx].quantity += 1);
      }
    }
    this.formVariants = items;
  }
  updateTotalPrice() {
    const prices = [],
      comparePrices = [],
      variants = this.selectedVariants;
    for (const key in variants) {
      const variant = variants[key];
      variant != null &&
        variant.checked &&
        (prices.push(parseInt(variant.price)), comparePrices.push(parseInt(variant.comparePrice)));
    }
    const totalPrice = prices.reduce((acc, p) => acc + p, 0),
      discountedTotal = totalPrice * this.percentageLeft - this.fixedDiscount,
      totalCompare = comparePrices.reduce((acc2, p2) => acc2 + p2, 0);
    ((this.totalPrice.innerHTML = this.currencySymbol + (discountedTotal / 100).toFixed(2)),
      totalCompare > discountedTotal
        ? (this.totalComparePrice.innerHTML = this.currencySymbol + (totalCompare / 100).toFixed(2))
        : (this.totalComparePrice.innerHTML = ''));
  }
}
customElements.define('bundle-deals', BundleDeals);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    (super(),
      (this.image = this.querySelector('.upsell__image__img')),
      (this.toggleBtn = this.querySelector('.upsell-toggle-btn')),
      (this.variantSelects = this.querySelector('.upsell__variant-picker')),
      (this.variantSelectElements = this.querySelectorAll('.select__select')),
      (this.jsonData = this.querySelector('[type="application/json"]')),
      (this.productForm = this.querySelector('product-form')));
    if (this.productForm) this.idInput = this.productForm.querySelector('[name="id"]');
    ((this.skipNonExistent = this.dataset.skipNonExistent === 'true'),
      (this.skipUnavailable = this.dataset.skipUnavailable === 'true'),
      (this.updatePrices = this.dataset.updatePrices === 'true'));
    if (this.updatePrices) {
      ((this.price = parseInt(this.dataset.price)),
        (this.comparePrice = parseInt(this.dataset.comparePrice)),
        (this.priceSpan = this.querySelector('.upsell__price .regular-price')),
        (this.comparePriceSpan = this.querySelector('.upsell__price .compare-price')),
        (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
        (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
        (this.moneyFormat = this.dataset.moneyFormat),
        (this.isMainOfferItem = this.dataset.mainOfferItem === 'true'));
      if (this.isMainOfferItem)
        this.mainOfferContainer = document.querySelector(
          '#MainBundleOffer-' + this.dataset.section,
        );
    }
    if (this.toggleBtn) this.toggleBtn.addEventListener('click', this.handleToggle.bind(this));
    if (this.variantSelects)
      this.variantSelects.addEventListener('change', this.handleSelectChange.bind(this));
  }
  handleToggle(event) {
    if (
      event.target.nodeName.toLowerCase() === 'select' ||
      event.target.nodeName.toLowerCase() === 'option'
    )
      return;
    this.dataset.selected === 'true'
      ? (this.dataset.selected = 'false')
      : (this.dataset.selected = 'true');
  }
  handleSelectChange(event2) {
    const target = event2.currentTarget,
      selectedValues = Array.from(target.querySelectorAll('select'), (s) => s.value),
      variant = this.getVariantData().find((v) => {
        return !v.options
          .map((opt2, i) => {
            return selectedValues[i] === opt2;
          })
          .includes(false);
      }),
      filteredVariants = this.getVariantData().filter(
        (v4) => target.querySelector(':checked').value === v4.option1,
      ),
      selects = [...target.querySelectorAll('select')];
    updateVariantStatuses(filteredVariants, selects);
    if (!variant) {
      if (this.skipNonExistent)
        findAvailableVariant(target, selectedValues, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !variant.available) {
      if (findAvailableVariant(target, selectedValues, false, true, true)) return;
    }
    this.updatePrices &&
      ((this.price = variant.price * this.percentageLeft - this.fixedDiscount),
      (this.comparePrice = variant.price),
      variant.compare_at_price &&
        variant.compare_at_price > variant.price &&
        (this.comparePrice = variant.compare_at_price),
      displayPrices(
        this.price,
        this.comparePrice,
        this.priceSpan,
        this.comparePriceSpan,
        this.moneyFormat,
      ));
    if (this.image && variant.featured_image) this.image.src = variant.featured_image.src;
    this.updateId(variant.id);
    if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices)
      this.mainOfferContainer.updateTotalPrices();
  }
  updateId(id) {
    this.dataset.id = id;
    if (this.idInput) this.idInput.value = id;
  }
  getVariantData() {
    return (
      (this.variantData = this.variantData || JSON.parse(this.jsonData.textContent)),
      this.variantData
    );
  }
}
customElements.define('product-info-upsell', ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    (super(),
      (this.cartDrawer = document.querySelector('cart-drawer')),
      (this.cartItems = this.cartDrawer.querySelector('cart-drawer-items')),
      (this.classicAddButton = this.querySelector('.upsell__add-btn')));
  }
  handleToggle(event) {
    if (
      event.target.nodeName.toLowerCase() === 'select' ||
      event.target.nodeName.toLowerCase() === 'option'
    )
      return;
    this.dataset.selected === 'true'
      ? ((this.dataset.selected = 'false'), this.removeFromCart())
      : ((this.dataset.selected = 'true'), this.addToCart());
  }
  addRemoveFromCart() {
    this.dataset.selected === 'true' && !this.cartDrawer.classList.contains('is-empty')
      ? this.addToCart()
      : this.removeFromCart();
  }
  addToCart() {
    const cartItem = this.cartDrawer.querySelector('.cart-item--product-' + this.dataset.handle);
    if (cartItem) return;
    if (this.toggleBtn) this.toggleBtn.setAttribute('disabled', '');
    (this.variantSelectElements.forEach((sel) => {
      sel.setAttribute('disabled', '');
    }),
      this.productForm.handleSubmit());
  }
  removeFromCart() {
    const existingItem = this.cartDrawer.querySelector(
      '.cart-item--product-' + this.dataset.handle,
    );
    if (!existingItem || !this.cartItems) return;
    if (this.toggleBtn) this.toggleBtn.setAttribute('disabled', '');
    (this.variantSelectElements.forEach((sel3) => {
      sel3.setAttribute('disabled', '');
    }),
      this.cartItems.updateQuantity(existingItem.dataset.index, 0));
  }
  updateId(id) {
    ((this.dataset.id = id), (this.idInput.value = id));
    if (this.classicAddButton) return;
    if (this.dataset.selected === 'true') {
      this.selectTimeout && clearTimeout(this.selectTimeout);
      this.removeFromCart();
      const handler = (e) => {
        e.detail.handle === 'handle' &&
          (this.addToCart(), document.removeEventListener('cartQuantityUpdated', handler));
      };
      document.addEventListener('cartQuantityUpdated', handler);
    }
  }
  getUpdateRequired() {
    const existingItem2 = this.cartDrawer.querySelector(
      '.cart-item--product-' + this.dataset.handle,
    );
    let needsUpdate = false;
    if (existingItem2 && this.dataset.selected === 'false') needsUpdate = true;
    else !existingItem2 && this.dataset.selected === 'true' && (needsUpdate = true);
    return needsUpdate;
  }
}
customElements.define('cart-drawer-upsell', CartDrawerUpsell);
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
  }
}
customElements.define('cart-drawer-gift', CartDrawerGift);
class MainBundleOffer extends HTMLElement {
  constructor() {
    (super(),
      (this.offerItems = this.querySelectorAll('.main-offer-item')),
      (this.updatePrices = this.dataset.updatePrices === 'true'),
      this.updatePrices &&
        ((this.priceSpan = this.querySelector('.bundle-deals__total-price-js')),
        (this.comparePriceSpan = this.querySelector('.bundle-deals__total-compare-price-js')),
        (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
        (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
        (this.moneyFormat = this.dataset.moneyFormat)));
  }
  updateTotalPrices() {
    if (!this.updatePrices) return;
    let totalPrice = 0,
      totalCompare = 0;
    for (let i = 0; i < this.offerItems.length; i++) {
      ((totalPrice += parseInt(this.offerItems[i].price)),
        (totalCompare += parseInt(this.offerItems[i].comparePrice)));
    }
    ((totalPrice = totalPrice * this.percentageLeft - this.fixedDiscount),
      displayPrices(
        totalPrice,
        totalCompare,
        this.priceSpan,
        this.comparePriceSpan,
        this.moneyFormat,
      ));
  }
}
customElements.define('main-bundle-offer', MainBundleOffer);
